(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  // 无限滚动：滚动到列表底部时，通过 Section Rendering API 加载下一页商品并追加到网格中
  if (!customElements.get('product-list-infinite-scroll')) {
    customElements.define(
      'product-list-infinite-scroll',
      class extends HTMLElement {
        connectedCallback() {
          this.loading = false;
          this.observer = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) this.loadNextPage();
            },
            { rootMargin: '0px 0px 400px 0px' }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        async loadNextPage() {
          const nextUrl = this.dataset.nextUrl;
          if (this.loading || !nextUrl) return;
          this.loading = true;

          try {
            const url = new URL(nextUrl, location.origin);
            url.searchParams.set('section_id', this.dataset.sectionId);
            const response = await fetch(url);
            if (!response.ok) throw new Error(response.statusText);

            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const list = this.parentElement.querySelector('.resource-list');
            html.querySelectorAll('.resource-list > .resource-list__item').forEach((item) => {
              list.appendChild(document.importNode(item, true));
            });

            const next = html.querySelector('product-list-infinite-scroll');
            if (next?.dataset.nextUrl) {
              this.dataset.nextUrl = next.dataset.nextUrl;
            } else {
              this.remove();
            }
          } catch (error) {
            console.error('Failed to load next page', error);
          } finally {
            this.loading = false;
          }

          // 加载后如果哨兵仍在可视范围内（内容不够一屏），继续加载
          if (this.isConnected) {
            this.observer.unobserve(this);
            this.observer.observe(this);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
